import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { db } from '../firebase';
import { collection, getDocs } from 'firebase/firestore';

function ProjectGantt() {
  const { id: projectId } = useParams();
  const [activities, setActivities] = useState([]);
  const [weekEnds, setWeekEnds] = useState([]);

  useEffect(() => {
    const fetchActivities = async () => {
      const stagesRef = collection(db, 'projects', projectId, 'stages');
      const stagesSnap = await getDocs(stagesRef);

      let allActivities = [];

      for (const stageDoc of stagesSnap.docs) {
        const stageData = stageDoc.data();
        const stageName = stageData.name;

        const stageActivities = (stageData.activities || []).map((activity, index) => ({
          ...activity,
          stageId: stageDoc.id,
          stageName,
          activityIndex: index
        }));

        allActivities = [...allActivities, ...stageActivities];
      }

      setActivities(allActivities);

      // Agora calcula range de semanas baseado nas plannedEnd
      const plannedDates = allActivities
        .map(act => act.plannedEnd)
        .filter(Boolean)
        .map(dateStr => new Date(dateStr));

      if (plannedDates.length === 0) {
        setWeekEnds([]); // Sem atividades → não gerar colunas
        return;
      }

      const minDate = new Date(Math.min(...plannedDates));
      const maxDate = new Date(Math.max(...plannedDates));

      const weeks = [];

      let cursor = new Date(minDate);

      // Garante que cursor começa no dia 1 da semana
      if (cursor.getDay() !== 0) {  // se não for domingo, retrocede até domingo
        cursor.setDate(cursor.getDate() - cursor.getDay());
      }

      while (cursor <= maxDate) {
        let weekEnd = new Date(cursor);
        weekEnd.setDate(cursor.getDate() + 6);

        const formatted = `${String(weekEnd.getDate()).padStart(2, '0')}/${String(weekEnd.getMonth() + 1).padStart(2, '0')}`;
        weeks.push({ label: formatted, date: new Date(weekEnd) });

        // Próxima semana
        cursor.setDate(cursor.getDate() + 7);
      }

      setWeekEnds(weeks);
    };

    fetchActivities();
  }, [projectId]);

  return (
    <div className="p-6 overflow-x-auto">
      <h2 className="text-2xl font-bold mb-4">Calendário de Atividades - Gantt (Semanas Reais)</h2>

      {weekEnds.length === 0 ? (
        <p>Sem atividades com data prevista.</p>
      ) : (
        <table className="table-auto border-collapse w-full whitespace-nowrap">
          <thead>
            <tr className="bg-gray-200">
              <th className="p-2 border">Etapa</th>
              <th className="p-2 border">Atividade</th>
              <th className="p-2 border">Status</th>
              {weekEnds.map((week, idx) => (
                <th key={idx} className="p-2 border text-center">
                  {week.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {activities.map((activity, idx) => {
              let plannedDate = null;

              if (activity.plannedEnd) {
                plannedDate = new Date(activity.plannedEnd);
              }

              return (
                <tr key={`${activity.stageId}-${idx}`} className="text-center">
                  <td className="p-2 border">{activity.stageName}</td>
                  <td className="p-2 border">{activity.title}</td>
                  <td className="p-2 border">{activity.status}</td>

                  {weekEnds.map((week, i) => {
                    let weekStart = new Date(week.date);
                    weekStart.setDate(week.date.getDate() - 6);

                    const isPlanned =
                      plannedDate &&
                      plannedDate >= weekStart &&
                      plannedDate <= week.date;

                    return (
                      <td key={i} className="p-2 border">
                        {isPlanned ? <span className="text-blue-600 text-lg">⬛</span> : ''}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default ProjectGantt;
